<div class="save-confirmation-dialog">
  <mat-dialog-content>
    <div class="mat-h3 title">
      <span class="mdi mdi-alert-circle-outline color-warn"></span>
      {{ data.title ?? 'Confirm Changes' }}
    </div>

    <div class="mat-body body">
      <div class="intro">{{ introMessage }}</div>

      <div class="consequence-list">
        @for (item of data.consequences; track item.name) {
          <div class="consequence-item">
            <div class="name">{{ item.name }}</div>
            @if (item.note) {
              <div class="note">{{ item.note }}</div>
            }
            <ul class="actions">
              @for (action of item.actions; track action.id) {
                <li [class.check-item]="action.skippable">
                  @if (action.skippable) {
                    <mat-checkbox [checked]="true" [class.skipped]="isSkipped(action.id)"
                                  (change)="onToggle(action.id, $event)">
                      {{ action.label }}
                    </mat-checkbox>
                    @if (isSkipped(action.id)) {
                      <div class="skip-hint color-warn">{{ skipHintFor(action) }}</div>
                    }
                  } @else {
                    {{ action.label }}
                  }
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>

    <div class="actions-row">
      <button mat-stroked-button color="primary" (click)="onSubmit(false)">Close</button>
      <button mat-flat-button color="primary" (click)="onSubmit(true)">Confirm</button>
    </div>
  </mat-dialog-content>
</div>
